var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExerciseEditor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 33,
    viewBox: "0 0 30 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16207 32H24.5172C26.9759 32 28.9 30.0759 28.9 27.6172C28.9 25.8 27.7241 24.0897 25.9069 23.4483L10.5138 18.1034C5.81035 16.6069 1 20.0276 1 24.8379C1 28.7931 4.2069 32 8.16207 32Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7586 28.7931C14.5297 28.7931 15.9655 27.3573 15.9655 25.5862C15.9655 23.8151 14.5297 22.3793 12.7586 22.3793C10.9875 22.3793 9.55173 23.8151 9.55173 25.5862C9.55173 27.3573 10.9875 28.7931 12.7586 28.7931Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6207 9.55172H7.2C5.27587 9.55172 3.45862 8.80345 2.06897 7.41379",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2414 5.27586C23.5552 5.27586 26.7621 3.67241 28.7931 1L20.2414 5.27586Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6207 9.55172H7.2C5.27587 9.55172 3.45862 8.80345 2.06897 7.41379M7.4138 9.55172L11.6897 18.1034M25.5862 4.2069L21.3103 21.3103M20.2414 5.27586C23.5552 5.27586 26.7621 3.67241 28.7931 1M12.7586 25.5862H19.1724M8.16207 32H24.5172C26.9759 32 28.9 30.0759 28.9 27.6172C28.9 25.8 27.7241 24.0897 25.9069 23.4483L10.5138 18.1034C5.81035 16.6069 1 20.0276 1 24.8379C1 28.7931 4.2069 32 8.16207 32ZM15.9655 25.5862C15.9655 27.3573 14.5297 28.7931 12.7586 28.7931C10.9875 28.7931 9.55173 27.3573 9.55173 25.5862C9.55173 23.8151 10.9875 22.3793 12.7586 22.3793C14.5297 22.3793 15.9655 23.8151 15.9655 25.5862Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExerciseEditor);
export default __webpack_public_path__ + "static/media/exercise-editor.d930d210.svg";
export { ForwardRef as ReactComponent };